import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { MultiSelect } from 'primereact/multiselect';
import { STATUS_BADGES, STATUS_FILTER_OPTIONS } from '../../utils/deliveryStatus';
import Badge from '../Badge/Badge';
import s from '../../styles/shared/page.module.css';
import table from '../../styles/shared/table.module.css';

export default function DeliveriesTable({
  rows,
  isEmpty,
  isLoading,
  emptyLabel,
  statusFilter,
  onStatusFilterChange,
  firstColumnHeader,
  firstColumnBody,
  firstColumnClassName,
}) {
  return (
    <>
      <div className={`${s.rangeBar} ${s.filterBar}`}>
        <MultiSelect
          value={statusFilter}
          onChange={(e) => onStatusFilterChange(e.value)}
          options={STATUS_FILTER_OPTIONS}
          placeholder="All statuses"
          display="chip"
          className={s.rangeDropdown}
        />
      </div>

      <div className={table.tableWrapper}>
        <DataTable
          value={rows}
          loading={isLoading}
          emptyMessage={
            isEmpty
              ? `No ${emptyLabel} in this range yet.`
              : `No ${emptyLabel} match the selected statuses.`
          }
          responsiveLayout="stack"
        >
          <Column header={firstColumnHeader} className={firstColumnClassName} body={firstColumnBody} />
          <Column
            header="Message"
            body={(d) => <div className={`${table.cellInsider} ${table.cellWrap}`}>{d.message_body}</div>}
          />
          <Column
            header="Status"
            body={(d) => (
              <div className={table.cellInsider}>
                <Badge {...STATUS_BADGES[d.rowStatus]}>{STATUS_BADGES[d.rowStatus].label}</Badge>
              </div>
            )}
          />
          <Column
            header="Reason"
            body={(d) => (
              <div className={`${table.cellInsider} ${table.cellWrap}`}>{d.error_reason || '—'}</div>
            )}
          />
          <Column
            header="When"
            className={s.mutedCell}
            body={(d) => <div className={table.cellInsider}>{new Date(d.created_at).toLocaleString()}</div>}
          />
        </DataTable>
      </div>
    </>
  );
}
